import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { PasswordResetForm } from "../../../../expert";
import PortalTextInput from "../../form-elements/portal-text-input/PortalTextInput";
import FormMessage from "../form-message/FormMessage";
import LoginButton from "../../buttons/login-button/LoginButton";
import { generalTextInputStyles } from "./PortalSignInForm";
const ForgotPasswordForm = ({
  classes,
  onVerificationCodeSent
}) => {
  return /*#__PURE__*/React.createElement(PasswordResetForm, {
    onVerificationCodeSent: onVerificationCodeSent
  }, ({
    email,
    fieldErrors,
    isFormInvalid,
    onEmailChange,
    onFormSubmit,
    loading,
    userErrorMessage
  }) => {
    return /*#__PURE__*/React.createElement("form", {
      className: classes.fieldContainer
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(FormMessage, {
      errorMessage: userErrorMessage,
      infoMessage: "A registration code will be sent to your email."
    })), /*#__PURE__*/React.createElement(PortalTextInput, {
      name: "email",
      label: "Email address",
      placeholder: "Your Email Address",
      id: "emailAddressInputField",
      onChange: event => onEmailChange(event.target.value),
      disabled: loading,
      value: email.value,
      error: fieldErrors.email ? true : false,
      helperText: fieldErrors.email,
      containerClass: classes.textInput,
      color: "primary",
      inputProps: {
        className: classes.textInputStyle
      },
      textInputClasses: {
        notchedOutline: classes.noBorderInput
      },
      errorLabel: true
    }), /*#__PURE__*/React.createElement(LoginButton, {
      disabled: loading || isFormInvalid,
      loading: loading,
      type: "submit",
      component: "button",
      onClick: onFormSubmit,
      id: "sendRegistrationCodeButton"
    }, "Send Code"));
  });
};
const styles = theme => ({
  ...generalTextInputStyles(theme),
  fieldContainer: {
    width: "100%",
    maxWidth: 325,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 220,
    textAlign: "left"
  },
  textInput: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 16,
    marginTop: 16
  }
});
export default withStyles(styles)(ForgotPasswordForm);
ForgotPasswordForm.propTypes = {
  classes: PropTypes.object.isRequired,
  errorMessage: PropTypes.string,
  infoMessage: PropTypes.string,
  onVerificationCodeSent: PropTypes.func.isRequired
};